<template>
  <div class="box profile-card-2">
    <div class="row">
      <div class="col-6" style="text-align: left">
        <span class="start_up_label">Looking for</span>
      </div>
      <div
        class="col-6"
        style="text-align: right"
        data-bs-toggle="modal"
        data-bs-target="#editLookingFor"
      >
        <span class="start_up_edit">Edit</span>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="row investor_list">
          <div
            class="investor_data"
            v-for="(data, i) in form.looking_for"
            :key="i"
          >
            {{ handleSelectName(data) }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="editLookingFor"
      tabindex="-1"
      aria-labelledby="editLookingForLabel"
      aria-hidden="true"
      style=""
    >
      <div class="modal-dialog" style="width: 550px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit Looking For/Roles</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form @submit="updateLookingFor">
            <div class="modal-body" style="padding: 30px; padding-top: 50px">
              <div v-if="fetchLookingForError != ''">
                <center>
                  <br />
                  <img
                    src="/img/cancel.png"
                    style="margin-top: 30px; width: 150px"
                  /><br /><br />
                  <p style="margin-top: 30px">
                    Error detected while loading Roles
                  </p>
                  <code>{{ this.fetchLookingForError }}</code>
                  <br /><br />
                </center>
              </div>
              <div class="form-grouped">
                <div class="list-wrapper" v-if="isLoadingLookingFor == true">
                  <img
                    src="/img/lightbox/preloader.gif"
                    style="margin-left: 10px"
                    class="button-spinner"
                  />
                </div>
                <div
                  class="chip-btn-container"
                  v-if="isLoadingLookingFor == false"
                >
                  <ChipButton
                    v-for="(item, index) in teamRolesArrData"
                    :key="index"
                    :text="item.name"
                    :dashedBorder="true"
                    :buttonIcon="
                      'img/onboarding/specify_preferences/' + item.img
                    "
                    :selected="checkedSelectedTeamRole(item.id)"
                    v-on:click="handleSelectTeamRole(item.id)"
                  />
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <div
                v-if="isUpdatedLookingFor"
                style="right: 0%; right: 0; margin-top: 0%; text-align: center"
                id="loaderCal"
              >
                <v-progress-circular
                  :size="30"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
                {{ "updating looking for/roles..." }}
              </div>

              <button
                v-if="!isUpdatedLookingFor"
                type="button"
                class="btn btn-light lightBorder p-3"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                v-if="!isUpdatedLookingFor && fetchLookingForError == ''"
                type="submit"
                class="btn btn-primary p-3"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="errorModalLookingFor"
      tabindex="-1"
      aria-labelledby="errorModalLookingForLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" style="width: 450px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ERROR DETECTED</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body" style="text-align: center">
            <br />
            <img
              src="/img/cancel.png"
              style="margin-top: 30px; width: 150px"
            /><br /><br />
            <p style="margin-top: 30px">Error detected while updating Roles</p>
            <code>{{ this.LookingForUpdateError }}</code>
            <br /><br />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light lightBorder"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="successChangeRequestModalLookingFor"
      tabindex="-1"
      aria-labelledby="successChangeRequestModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" style="width: 450px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Looking For/Roles Updated</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body" style="text-align: center">
            <br />
            <img
              src="/img/marked.svg"
              style="margin-top: 30px; width: 150px"
            /><br /><br />
            <p style="margin-top: 30px">
              Looking For/Roles record updated successfully
            </p>
            <br /><br />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              data-bs-dismiss="modal"
              class="btn btn-light lightBorder"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateLookingFor } from "@/api/client";
import ChipButton from "@/components/chipButton/chipButton";
import { getRoles } from "@/api/client";

import { mapActions } from "vuex";

export default {
  props: ["form", "project_id", "startup_id"],
  data: () => ({
    LookingForUpdateError: "",
    fetchLookingForError: "",
    teamRolesArrData: [],
    isLoadingLookingFor: false,
    isUpdatedLookingFor: false,
  }),
  components: {
    ChipButton,
  },
  created() {
    getRoles()
      .then((data) => {
        //console.log(data.data.data)
        let response = data.data.data;
        this.isLoadingLookingFor = false;

        for (var i = 0; i < response.length; i++) {
          this.teamRolesArrData.push({
            name: response[i].name,
            value: response[i].id,
            id: response[i].id,
            img: response[i].img,
          });
        }

        // console.log(this.teamRolesArrData);
        //console.log(this.projectIndustries)
      })
      .catch((error) => {
        this.isLoadingLookingFor = false;
        this.fetchLookingForError = error;
        console.log(error);
      });
  },

  computed: {
    checkedSelectedTeamRole() {
      return (value) => {
        let selected = this.form.looking_for;
        const foundItem = selected.find((item) => item == value);
        return foundItem ? true : false;
      };
    },
  },
  mounted() {
    console.log("form:: ", this.form.looking_for);
    // console.log("all:: ", this.projectToolsData);
  },
  methods: {
    ...mapActions("clientDashboard", ["updateProject"]),
    getStackTools(data, value) {
      // console.log(data);
      const language = data.filter((item) => item._type == value);
      return language;
    },
    handleSelectTeamRole(value) {
      let selected = this.form.looking_for;
      if (selected) {
        const currentValue = selected.find((item) => item == value);
        if (!currentValue) {
          this.form.looking_for.push(value);
        } else {
          this.form.looking_for = selected.filter((item) => item !== value);
        }
      }
    },
    handleSelectName(value) {
      const currentValue = this.teamRolesArrData.find(
        (item) => item.id == value
      );
      if (currentValue) {
        return currentValue.name;
      }
     // console.log(value);
      //console.log(currentValue.name);
    },
    async updateLookingFor(event) {
      event.preventDefault();

      const payload = {
        project_id: this.project_id,

        looking_for: this.form.looking_for,
        startup_id: this.startup_id,
      };

      console.log(payload);

      this.isUpdatedLookingFor = true;

      //stack
      await updateLookingFor(payload)
        .then(async (response) => {
          this.isUpdatedLookingFor = false;
          $("#editLookingFor").modal("hide");

          const { project } = response.data.data;

          if (response.data.status == 1) {
            this.updateProject(project);
             localStorage.removeItem("engineerRole");

            $("#successChangeRequestModalLookingFor").modal("show");

            //
          } else {
            this.LookingForUpdateError = response.data.errors;
            $("#errorModalLookingFor").modal("show");
          }
        })
        .catch((error) => {
          $("#editLookingFor").modal("hide");
          this.isUpdatedLookingFor = false;
          if (error.hasOwnProperty("message")) {
            this.LookingForUpdateError = error.message;
          } else {
            this.LookingForUpdateError = error.data.errors;
          }

          $("#errorModalLookingFor").modal("show");
        });

      //console.log(payload);
    },
  },
};
</script>

<style scoped>
.lightBorder {
  border: 1px solid #eee;
}
.modal {
  text-align: center;
}

@media screen and (min-width: 768px) {
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.modal_label {
  font-family: "Moderat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 145%;
  /* identical to box height, or 20px */

  display: flex;
  align-items: center;

  /* primary/700 (text) */

  color: #1b1e22;
  padding-bottom: 10px;
}

.profile-card-2 {
  text-align: left;
  background: #ffffff;

  border-bottom: 1px solid #eee;
  padding: 20px;
}
.start_up_line {
  border: 0.5px solid #e4e5e7;
}

.start_up_data {
  font-family: "Moderat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  padding-top: 30px;
  padding-bottom: 20px;

  color: #1b1e22;
}
.start_up_edit {
  font-family: "Moderat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;

  text-align: right;
  cursor: pointer;
  color: #0781f2;
}
.start_up_label {
  font-family: "Moderat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;

  text-transform: uppercase;

  color: #979da5;
}

.investor_data {
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  width: auto;

  height: 31px;

  /* primary/0 */

  background: #ffffff;
  /* primary/100 */

  border: 1px solid #e4e5e7;
  border-radius: 8px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.investor_list {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  padding: 20px;
  padding-top: 20px;
}

div.title {
  text-align: left;
  padding-top: 56px;
  padding-left: 5px;
  font-size: 23px;
  font-weight: bold;
}
.form-container {
  width: 588px;
  padding-top: 20px;
}
.div-label {
  text-align: left;
  font-size: 14px;
  padding-bottom: 5px;
  font-size: 14px;
  line-height: 145%;
}
.form-control {
  border: 1px solid #e4e5e7;
}
.form-control {
  margin-top: 4px;
  margin-bottom: 0px;
}
.form-grouped {
  margin-top: 0px;
}

.form_errors {
  color: red;
}
.check-product-name {
  text-align: left;
  font-weight: normal;
  font-size: 14px;
  line-height: 145%;
  color: #1b1e22;
  margin-top: 8px;
}
.light-label {
  font-weight: normal;
  font-size: 14px;
  line-height: 145%;
  color: #979da5;
  margin-top: 8px;
  text-align: left;
}
.chip-btn-container {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
}
.button-container {
  /*display: flex;*/
  justify-content: flex-end;
  margin: 48px 0px;
  float: left;
}
.text-box-hint {
  font-size: 14px;
  line-height: 130%;
  color: #979da5;
  text-align: left;
  margin-top: 8px;
}
.medium-combo-box .v-text-field {
  border: 1px solid #e4e5e7;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 14px;
  line-height: 130%;
}

.textbox-wrapper {
  display: flex;
}
.textbox-wrapper div {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  color: #495057;
  /* background-color: #fff; */
  margin-top: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 0;
  width: 42px;
  background: black;
  color: white;
  height: 51px;
}
.light-text-label {
  color: #979da5;
}
.display-inline {
  display: inline-block;
  /* padding-top: 50px; */
}
.list-wrapper {
  display: flex;
  margin-top: 5px;
  gap: 12px;
  width: 100%;
  flex-wrap: wrap;
}
.label-description {
  color: #979da5;
}
.brief_counter {
  margin-bottom: 28px;
}
@media (max-width: 768px) {
  .form-container {
    width: 100%;
  }
  .button-container {
    float: none;
  }
  .grupa-blue-btn {
    width: 100%;
  }
  .list-wrapper {
    width: 100%;
  }
  div.title {
    padding-top: 32px;
  }
  .chip-btn-container {
    width: 100%;
  }
  .form-grouped {
    margin-top: 32px;
  }
}
</style>
